export function validarNomeCompleto(nome?: string): boolean {
    return (nome || '').trim().split(/\s+/).filter(Boolean).length >= 2;
}
